module.exports = __webpack_public_path__ + "assets/img/4_358_big.781459b5.jpg";